import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ApiHelper} from './api.helper';
import {AppConfigService} from "./app-config.service";

@Injectable()
export class PlaceService {
  constructor(
    private http: HttpClient,
    private apiHelper: ApiHelper,
    private appConfigService: AppConfigService
  ) {
  }

  public hasAncestor(
    placeId: number,
    ancestorPlaceId: number
  ): Observable<boolean> {
    const endpoint = `${this.appConfigService.appConfig.apiUrl}place/${placeId}/has-ancestor/${ancestorPlaceId}`;

    return this.http
      .get<boolean>(endpoint)
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }
}
